import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
const Context = createContext(null);
export function AdsTargetingDataProvider({ value, children, }) {
    const stable = useMemo(() => value, [value]);
    return _jsx(Context.Provider, { value: stable, children: children });
}
/** Данные виджетов таргетинга; без провайдера — понятная ошибка (а не молчаливо пустой список). */
export function useAdsTargetingData() {
    const v = useContext(Context);
    if (v === null) {
        throw new Error('useAdsTargetingData: нет AdsTargetingDataProvider — оберните виджеты таргетинга в провайдер');
    }
    return v;
}
//# sourceMappingURL=data.js.map